import React, { useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Grid,
  CardHeader,
  Avatar,
  IconButton,
  Button,
  TextField,
} from '@material-ui/core';
import { alertError, formatNumberComma, seconds2time } from '../../Util/Util';
import { map } from 'lodash';
import CancelIcon from '@material-ui/icons/Cancel';
import MonetizationOnRoundedIcon from '@material-ui/icons/MonetizationOnRounded';
import ErrorOutlineRoundedIcon from '@material-ui/icons/ErrorOutlineRounded';
import SupervisedUserCircleRoundedIcon from '@material-ui/icons/SupervisedUserCircleRounded';
import ArrowBackRoundedIcon from '@material-ui/icons/ArrowBackRounded';
import Swal from 'sweetalert2';
import ChatRoundedIcon from '@material-ui/icons/ChatRounded';
import CreateRoundedIcon from '@material-ui/icons/CreateRounded';
import CheckRoundedIcon from '@material-ui/icons/CheckRounded';
import ClearRoundedIcon from '@material-ui/icons/ClearRounded';
import InfoRoundedIcon from '@material-ui/icons/InfoRounded';

const GuestCardHistoryDetail = (props) => {
  const {
    history,
    closeDrawer,
    getGuestCardHistoryTypePrices,
    setGuestCardHistoryType,
    refreshHistoryList,
    saveAuditComment,
  } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [typePrices, setTypePrices] = useState();
  const [isEditComment, setIsEditComment] = useState(false);
  const [editAuditComment, setEditAuditComment] = useState();

  const handleClose = () => {
    closeDrawer();
  };

  const handleSetTypePrice = () => {
    setIsLoading(true);

    getGuestCardHistoryTypePrices(history.id)
      .then(
        (rs) => {
          setTypePrices(rs.priceTypeList);
        },
        (error) => {
          alertError(error);
        },
      )
      .then(() => {
        setIsLoading(false);
      });
  };

  const handleCancelSetTypePrice = () => {
    setTypePrices(undefined);
  };

  const setHistoryType = (typeId) => {
    Swal.fire({
      title: '確認設定',
      text: '設定後將無法更改，是否繼續？',
      icon: 'warning',
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonText: '確認',
      cancelButtonText: '取消',
    }).then((rs) => {
      if (rs.isConfirmed) {
        setIsLoading(true);

        setGuestCardHistoryType(history.id, typeId, history.auditComment)
          .then(
            () => {
              Swal.fire({
                title: '設定成功',
                text: '已成功設定結帳類型',
                icon: 'success',
              });
              setTypePrices(undefined);
              refreshHistoryList();
            },
            (error) => {
              alertError(error);
            },
          )
          .then(() => {
            setIsLoading(false);
          });
      }
    });
  };

  const handleClickModifyComment = () => {
    setIsEditComment(true);
    setEditAuditComment(history.auditComment);
  };

  const handleCancelEditComment = () => {
    setIsEditComment(false);
    setEditAuditComment(undefined);
  };

  const handleSaveAuditComment = () => {
    setIsLoading(true);

    saveAuditComment(history.id, editAuditComment)
      .then(
        () => {
          Swal.fire({
            title: '儲存成功',
            text: '備註已成功儲存',
            icon: 'success',
          });
          setEditAuditComment(undefined);
          setIsEditComment(false);
          refreshHistoryList();
        },
        (error) => {
          alertError(error);
        },
      )
      .then(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className="bonus__view">
      <div className="bonus__close-view">
        關閉
        <IconButton onClick={handleClose}>
          <CancelIcon />
        </IconButton>
      </div>

      {history && (
        <Grid
          container
          direction="column"
          justifycontent="flex-start"
          alignItems="stretch"
          spacing={3}>
          <Grid item xs={12}>
            <Card variant="outlined">
              <CardHeader
                avatar={
                  <>
                    {history.cardType ? (
                      <Avatar src={history.cardType.frontImgUrl}></Avatar>
                    ) : (
                      <Avatar>
                        <ErrorOutlineRoundedIcon />
                      </Avatar>
                    )}
                  </>
                }
                title={
                  <Typography variant="h3">
                    {history.cardType && history.cardType.name}
                  </Typography>
                }
                subheader={history.cardType && history.cardType.description}
              />

              <CardContent>
                <Grid
                  container
                  direction="row"
                  justifycontent="space-around"
                  alignItems="stretch"
                  spacing={2}>
                  <Grid item xs={6}>
                    <Typography color="textSecondary">狀態</Typography>
                    <Typography variant="h6">
                      {history.historyStatus === 'bill' ? '已結帳' : '使用中'}
                    </Typography>
                  </Grid>

                  <Grid item xs={6}>
                    <Typography color="textSecondary">金額</Typography>
                    <Typography variant="h6">
                      {history.historyStatus === 'bill' && (
                        <span>
                          $ {formatNumberComma(history.expenseAmount)}
                        </span>
                      )}
                    </Typography>
                  </Grid>

                  {history.useTarget === 'card' && (
                    <>
                      <Grid item xs={6}>
                        <Typography color="textSecondary">CardId</Typography>
                        <Typography variant="h6">
                          {history.cardInfo.id}
                        </Typography>
                      </Grid>

                      <Grid item xs={6}>
                        <Typography color="textSecondary">CardCode</Typography>
                        <Typography variant="h6">
                          {history.cardInfo.code}
                        </Typography>
                      </Grid>
                    </>
                  )}

                  {history.useTarget === 'user' && (
                    <>
                      <Grid item xs={6}>
                        <Typography color="textSecondary">UserId</Typography>
                        <Typography variant="h6">
                          {history.userInfo.id}
                        </Typography>
                      </Grid>

                      <Grid item xs={6}>
                        <Typography color="textSecondary">姓名</Typography>
                        <Typography variant="h6">
                          {history.userInfo.realName}
                        </Typography>
                      </Grid>
                    </>
                  )}

                  <Grid item xs={6}>
                    <Typography color="textSecondary">使用時間</Typography>
                    <Typography variant="h6">
                      {seconds2time(history.useTimeSec, true)}
                    </Typography>
                  </Grid>

                  <Grid item xs={12}>
                    <Typography color="textSecondary">進場時間</Typography>
                    <Typography variant="h6">{history.signInTime}</Typography>
                  </Grid>

                  <Grid item xs={12}>
                    <Typography color="textSecondary">出場時間</Typography>
                    <Typography variant="h6">{history.signOutTime}</Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12}>
            <Card variant="outlined">
              <CardHeader
                avatar={
                  <Avatar>
                    <MonetizationOnRoundedIcon />
                  </Avatar>
                }
                title={<Typography variant="h3">使用算法</Typography>}
                subheader={`當時結算記錄`}
              />

              <CardContent>
                {history.historyStatus !== 'bill' && (
                  <Typography color="error" variant="h6">
                    尚未結帳，無法顯示使用算法
                  </Typography>
                )}

                {history.historyStatus === 'bill' && (
                  <Grid
                    container
                    direction="row"
                    justifycontent="space-around"
                    alignItems="stretch"
                    spacing={2}>
                    <Grid item xs={6}>
                      <Typography color="textSecondary">初始分鐘</Typography>
                      <Typography variant="h6">
                        {history.initialMinutes}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography color="textSecondary">初始價格</Typography>
                      <Typography variant="h6">
                        {history.initialPrice}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography color="textSecondary">時段分鐘</Typography>
                      <Typography variant="h6">
                        {history.periodMinutes}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography color="textSecondary">時段價格</Typography>
                      <Typography variant="h6">
                        {history.periodPrice}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography color="textSecondary">優惠分鐘</Typography>
                      <Typography variant="h6">
                        {history.discountMinutes}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography color="textSecondary">
                        最高收費分鐘
                      </Typography>
                      <Typography variant="h6">
                        {history.maxChargeMinutes}
                      </Typography>
                    </Grid>

                    {!history.cardType && (
                      <Grid item xs={12}>
                        {typePrices && typePrices.length > 0 ? (
                          <>
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                gap: '8px',
                                marginTop: '8px',
                                marginBottom: '8px',
                                padding: '8px',
                                flexWrap: 'wrap',
                                justifyContent: 'space-around',
                                alignItems: 'stretch',
                              }}>
                              {map(typePrices, (typePrice) => (
                                <Button
                                  variant="contained"
                                  color="primary"
                                  key={typePrice.typeId}
                                  style={{ display: 'block' }}
                                  onClick={() => {
                                    setHistoryType(typePrice.typeId);
                                  }}>
                                  {typePrice.typeName}
                                  <div
                                    style={{
                                      fontSize: '1.2rem',
                                      fontWeight: '600',
                                      margin: '0 6px',
                                    }}>
                                    {formatNumberComma(typePrice.price)}
                                  </div>
                                </Button>
                              ))}
                            </div>
                            <Button
                              variant="contained"
                              color="default"
                              size="small"
                              startIcon={<ArrowBackRoundedIcon />}
                              disabled={isLoading}
                              onClick={handleCancelSetTypePrice}>
                              取消設定
                            </Button>
                          </>
                        ) : (
                          <Button
                            variant="contained"
                            color="secondary"
                            size="small"
                            startIcon={<SupervisedUserCircleRoundedIcon />}
                            disabled={isLoading}
                            onClick={handleSetTypePrice}>
                            {!isLoading ? '設定結帳類型' : '載入類型金額中...'}
                          </Button>
                        )}
                      </Grid>
                    )}
                  </Grid>
                )}
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12}>
            <Card variant="outlined">
              <CardHeader
                avatar={
                  <Avatar>
                    <ChatRoundedIcon />
                  </Avatar>
                }
                title={<Typography variant="h3">備註</Typography>}
              />

              <CardContent>
                {!isEditComment && (
                  <>
                    <div
                      style={{
                        backgroundColor: '#f5f5f5',
                        padding: '8px',
                        marginBottom: '8px',
                        borderRadius: '4px',
                      }}>
                      {history.auditComment}
                    </div>

                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      startIcon={<CreateRoundedIcon />}
                      onClick={handleClickModifyComment}>
                      修改備註
                    </Button>
                  </>
                )}

                {isEditComment && (
                  <div>
                    <TextField
                      label="修改備註"
                      variant="outlined"
                      fullWidth
                      multiline
                      rows={5}
                      value={editAuditComment || ''}
                      onChange={(e) => {
                        setEditAuditComment(e.target.value);
                      }}
                      disabled={isLoading}
                    />
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: '8px',
                        marginTop: '8px',
                        justifyContent: 'space-between',
                      }}>
                      <Button
                        variant="contained"
                        color="default"
                        size="small"
                        startIcon={<ClearRoundedIcon />}
                        onClick={handleCancelEditComment}
                        disabled={isLoading}>
                        取消
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        startIcon={<CheckRoundedIcon />}
                        onClick={handleSaveAuditComment}
                        disabled={isLoading}>
                        儲存
                      </Button>
                    </div>
                  </div>
                )}
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12}>
            <Card variant="outlined">
              <CardHeader
                avatar={
                  <Avatar>
                    <InfoRoundedIcon />
                  </Avatar>
                }
                title={<Typography variant="h3">其他資訊</Typography>}
              />

              <CardContent>
                <Grid
                  container
                  direction="row"
                  justifycontent="space-around"
                  alignItems="stretch"
                  spacing={2}>
                  <Grid item xs={6}>
                    <Typography color="textSecondary">建立者ID</Typography>
                    <Typography variant="h6">
                      {history.createdUserId}
                    </Typography>
                  </Grid>

                  <Grid item xs={6}>
                    <Typography color="textSecondary">最後修改人員</Typography>
                    <Typography variant="h6">
                      {history.modifiedUserInfo
                        ? history.modifiedUserInfo.realName
                        : ''}
                    </Typography>
                  </Grid>

                  <Grid item xs={12}>
                    <Typography color="textSecondary">最後修改時間</Typography>
                    <Typography variant="h6">{history.modifiedDate}</Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      )}
    </div>
  );
};

export default GuestCardHistoryDetail;
